<ng-template #serviceProviderModal>
  <div class="offcanvas-header pb-0">
    <h4 class="modal-title mt-0 text-center w-100">{{ "heading-title.service-providers" | translate }}</h4>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  @if(cartServiceItemMainCategory.serviceSetting?.isAllowServiceProviderSelection && cartServiceItemMainCategory.serviceSetting?.isAllowCompanySelection){
  <div class="d-flex justify-content-center align-items-center mt-3">
    <div class="btn-group" role="group" aria-label="Basic example">
      <button type="button" class="btn" [ngClass]="{ 'btn-dark': isIndividualProvider, 'btn-light': !isIndividualProvider }" (click)="toggleIndividuals()">
        {{ "button-title.individuals" | translate }}
      </button>
      <button type="button" class="btn" [ngClass]="{ 'btn-dark': !isIndividualProvider, 'btn-light': isIndividualProvider }" (click)="toggleCompanies()">
        {{ "button-title.companies" | translate }}
      </button>
    </div>
  </div>
  }

  <!-- Sort By Section -->
  <div class="mt-3 px-3 pb-3 divider">
    <h5 class="fw-bold">{{ "label-title.sort-by" | translate }}</h5>
    <div class="d-flex gap-2 mt-2">
      <button class="btn" [ngClass]="selectedSortBy === 'price' ? 'btn-dark' : 'btn-light'" (click)="onSortChange('price')">{{ "button-title.price-low-high" | translate }}</button>
      <button class="btn" [ngClass]="selectedSortBy === 'ratings' ? 'btn-dark' : 'btn-light'" (click)="onSortChange('ratings')">{{ "button-title.ratings" | translate }}</button>
    </div>
  </div>

  @if(providers && providers.length > 0){
    <!-- Provider List Section -->
    <div class="mt-2 px-3 overflow-y-auto">
      @for (provider of providers; track $index) {
      <div class="d-flex align-items-start gap-3 py-3 provider-item" (click)="selectProvider(provider)">
        <!-- Provider Image -->
        <img
          [src]="provider.imageUrl ? helper.imageUrl + provider.imageUrl : 'assets/images/default-image.jpg'"
          class="rounded"
          alt="Provider"
          width="60"
          height="60"
          (error)="handleImageError($event)"
        />
  
        <!-- Provider Details -->
        <div class="flex-grow-1">
          <div class="d-flex align-items-center gap-2">
            <span class="fs-16 fw-bold">{{ provider.name ? provider.name : provider.firstName + " " + provider.lastName }}</span>
            @if(provider.customerRate || provider.rate){
            <span class="rating"><i class="ri-star-s-fill me-1"></i>{{ provider.rate ? provider.rate.toFixed(1) : provider.customerRate.toFixed(1) }}</span>
            }
          </div>
          @for(product of provider.products; track $index){
          <div class="text-muted fs-16">
            {{ product.qty > 1 ? product.name + " x " + product.qty : product.name }}
          </div>
          }
        </div>
  
        <!-- Pricing -->
        <div class="text-end">
          <div class="d-flex align-items-center fw-bold text-dark fs-16">
            <span class="ms-1">
              {{ provider.totalDiscountedPrice.toFixed(helper.adminSettings?.decimalPointValue) }}
            </span>
            <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
              {{ helper.currencySign }}
            </span>
          </div>
          @for(product of provider.products; track $index){
          <div class="d-flex align-items-center text-muted fs-16">
            <span class="ms-1">
              {{ (product.discountedPrice * product.qty).toFixed(helper.adminSettings?.decimalPointValue) }}
            </span>
            <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
              {{ helper.currencySign }}
            </span>
          </div>
          }
        </div>
      </div>
      }
    </div>
  } @else {
    <div class="d-flex justify-content-center align-items-center h-100">
      <h3>{{ "label-title.no-data-found" | translate }}</h3>
    </div>
  }
</ng-template>
